export const feriado = [
  {
    label: "Id",
    name: "idferiado",
    type: "INTEGER",
    readonly: true,
    showOnList: true,
  },
  {
    label: "Oficina",
    name: "idoficina",
    type: "oficina",
    allowNull: false,
    showOnList: true,
  },
  {
    label: "Nombre",
    name: "nombre",
    type: "STRING",
    allowNull: false,
    showOnList: true,
    showAsLabel: true,
  },
  {
    label: "Fecha",
    name: "fecha",
    type: "DATE",
    allowNull: false,
    showOnList: true,
  },
];
